import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import MainPage from './pages/MainPage';
import DemoPage from './pages/DemoPage';
import ReportDemoPage from './pages/ReportDemoPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/report-demo" element={<ReportDemoPage />} />
        </Routes>
      </HashRouter>
    </AuthProvider>
  );
}

export default App;
